import React from 'react';

import type { ViewPageRightSidebarProps } from 'app/main/components/page-layouts/details/components/ViewPageRightSidebarWrapper';
import { executeStored } from 'app/main/components/Utils';
import { useDispatch } from 'react-redux';
import type { PhoneCallsPageRightSidebarProps } from '../components/PhoneCallsPageRightSidebarWrapper';
import PhoneCallsChart from '../components/PhoneCallsChart';
import PhoneCallsPieChart from '../components/PhoneCallsPieChart';
import { useSettings } from 'app/main/components';

export default function PhoneCallsRightSidebar(props: PhoneCallsPageRightSidebarProps) {
	const sections: React.ReactNode[] = [];
	const { t } = useSettings();

	sections.push(<PhoneCallsChart filters={props.filters} refresh={props.refresh} />);
	sections.push(
		<PhoneCallsPieChart
			title={t('PHONECALLS_PIECHART_COMPANIES_TITLE')}
			filters={props.filters}
			field="comp_title"
			formatGroupLabel={({ group }) => group || t('PHONECALLS_CHART_NO_COMPANY')}
			columns={['phca_duration']}
			refresh={props.refresh}
		/>
	);
	sections.push(
		<PhoneCallsPieChart
			title={t('PHONECALLS_PIECHART_DIRECTION_TITLE')}
			filters={props.filters}
			field="phca_direction"
			formatGroupLabel={({ group }) => t(`PHONECALLS_DIRECTION_${group}`)}
			columns={['phca_duration']}
			refresh={props.refresh}
		/>
	);

	return sections;
}
